<div class="wrapper">
    <highcharts-chart
    class="highchart"
    [Highcharts]="highCharts"
    [options]="chartOptions"
    (chartInstance)="setChartInstance($event)"
    ></highcharts-chart>
    <span class="description">{{ descriptionKey | translate }}</span>
    <span [style.top.px]="size/2" class="progress">{{ value }}</span>
</div>
